import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketCustomerInfo } from '../../../../state';
import { useGraphProfile } from '../../../../hooks';

const CustomerRoleEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { graphData } = useGraphProfile();

  useEffect(() => {
    if (graphData?.jobTitle && !currentTicket?.customerInfo.customerRole) {
      dispatch(updateTicketCustomerInfo({ customerRole: graphData.jobTitle }));
    }
  }, [dispatch, graphData, currentTicket?.customerInfo.customerRole]);

  return (
    <TextField
      label="Role"
      size="small"
      fullWidth
      value={currentTicket?.customerInfo.customerRole || ''}
      placeholder="Auto-populated from user profile"
      disabled={true}
    />
  );
};

export default CustomerRoleEdit;
